import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDSapUser_Form_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDSapUser_Form_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  SelectSTDSapUser1: any[];
  SelectSTDSapUser1_dummy: any[];
  SaveRecord_1: number;
  SaveRecord_1_dummy: number;
}

export class STDSapUser_Form_ScreenBase extends React.PureComponent<
  ISTDSapUser_Form_ScreenProps,
  any
> {
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "3cc98d82-1ca5-4cc4-aa56-c8eb588926c2",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 796540, PropertyName: "value", Value: "STDSap user Form" },
        { Id: 8015127, PropertyName: "value", Value: "UserName" },
        { Id: 6800468, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 5694874, PropertyName: "value", Value: "UserNumber" },
        { Id: 5221612, PropertyName: "placeholder", Value: "15" },
        { Id: 1455290, PropertyName: "value", Value: "UserPassword" },
        { Id: 8317016, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 9544, PropertyName: "label", Value: "Save" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdsapuser_form_6800468_value_kuikaTextInputRef = React.createRef();
    this.stdsapuser_form_8317016_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      SelectSTDSapUser1: [],
      SaveRecord_1: 0,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdsapuser_form", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDSapUser_FormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdsapuser_form", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdsapuser_form", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDSapUser_FormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stdsapuser_form_6800468_value:
        this.state.SelectSTDSapUser1?.at?.(0)?.userName ?? undefined,
      stdsapuser_form_5221612_value:
        this.state.SelectSTDSapUser1?.at?.(0)?.userNumber ?? undefined,
      stdsapuser_form_8317016_value:
        this.state.SelectSTDSapUser1?.at?.(0)?.userPassword ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDSapUser_FormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDSapUser_Form/STDSapUser_FormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectSTDSapUser1 = result?.data.selectSTDSapUser1;
    formVars.stdsapuser_form_6800468_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDSapUser1 !== undefined
        ? stateVars.SelectSTDSapUser1?.length > 0
          ? stateVars.SelectSTDSapUser1[0].userName
          : null
        : this.state.SelectSTDSapUser1?.length > 0
        ? this.state.SelectSTDSapUser1[0].userName
        : null
    );
    formVars.stdsapuser_form_5221612_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDSapUser1 !== undefined
        ? stateVars.SelectSTDSapUser1?.length > 0
          ? stateVars.SelectSTDSapUser1[0].userNumber
          : null
        : this.state.SelectSTDSapUser1?.length > 0
        ? this.state.SelectSTDSapUser1[0].userNumber
        : null
    );
    formVars.stdsapuser_form_8317016_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDSapUser1 !== undefined
        ? stateVars.SelectSTDSapUser1?.length > 0
          ? stateVars.SelectSTDSapUser1[0].userPassword
          : null
        : this.state.SelectSTDSapUser1?.length > 0
        ? this.state.SelectSTDSapUser1[0].userPassword
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDSapUser_FormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDSapUser_FormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdsapuser_form_6800468_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDSapUser1 !== undefined
        ? stateVars.SelectSTDSapUser1?.length > 0
          ? stateVars.SelectSTDSapUser1[0].userName
          : null
        : this.state.SelectSTDSapUser1?.length > 0
        ? this.state.SelectSTDSapUser1[0].userName
        : null
    );

    formVars.stdsapuser_form_5221612_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDSapUser1 !== undefined
        ? stateVars.SelectSTDSapUser1?.length > 0
          ? stateVars.SelectSTDSapUser1[0].userNumber
          : null
        : this.state.SelectSTDSapUser1?.length > 0
        ? this.state.SelectSTDSapUser1[0].userNumber
        : null
    );

    formVars.stdsapuser_form_8317016_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDSapUser1 !== undefined
        ? stateVars.SelectSTDSapUser1?.length > 0
          ? stateVars.SelectSTDSapUser1[0].userPassword
          : null
        : this.state.SelectSTDSapUser1?.length > 0
        ? this.state.SelectSTDSapUser1[0].userPassword
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDSapUser_FormComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDSapUser_FormComponent_9544_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdsapuser_form_6800468_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      UserNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdsapuser_form_5221612_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      UserPassword_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdsapuser_form_8317016_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDSapUser_Form/STDSapUser_FormComponent_9544_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveRecord_1 = result?.data.saveRecord_1;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDSapUser_FormComponent_9544_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDSapUser_FormComponent_9544_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
